import { render, staticRenderFns } from "./PersonInfo.vue?vue&type=template&id=06b29c21&scoped=true"
import script from "./PersonInfo.vue?vue&type=script&lang=js"
export * from "./PersonInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonInfo.vue?vue&type=style&index=0&id=06b29c21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b29c21",
  null
  
)

export default component.exports